import React from 'react';
import IconBase from './IconBase';
import {Tooltip} from 'antd';

const AddPreTestIcon = props => {
    const {tooltipprops, iconprops} = {...props}

    // console.log('tooltipProps: ',tooltipprops);

    return (
        <Tooltip  {...tooltipprops} >
            <span><IconBase {...iconprops} >
                <g>
                    <path d="M30.1,40.1c0-0.4-0.1-0.6-0.4-0.8c-0.2-0.2-0.7-0.4-1.3-0.6c-0.6-0.2-1.1-0.4-1.5-0.6c-1.3-0.6-1.9-1.5-1.9-2.6
		c0-0.6,0.2-1,0.5-1.5c0.3-0.4,0.8-0.7,1.4-1c0.6-0.2,1.2-0.4,2-0.4c0.7,0,1.4,0.1,1.9,0.4c0.6,0.3,1,0.6,1.3,1.1
		c0.3,0.5,0.5,1,0.5,1.6h-2.4c0-0.4-0.1-0.7-0.4-0.9c-0.2-0.2-0.6-0.3-1-0.3s-0.8,0.1-1,0.3s-0.4,0.4-0.4,0.7s0.1,0.5,0.4,0.7
		s0.8,0.4,1.4,0.6c0.7,0.2,1.3,0.5,1.7,0.7c1.1,0.6,1.6,1.5,1.6,2.6c0,0.9-0.3,1.6-1,2.1c-0.7,0.5-1.5,0.7-2.7,0.7
		c-0.8,0-1.5-0.1-2.2-0.4c-0.7-0.3-1.1-0.7-1.5-1.2c-0.3-0.5-0.5-1.1-0.5-1.7H27c0,0.5,0.1,0.9,0.4,1.2s0.7,0.4,1.3,0.4
		c0.4,0,0.7-0.1,0.9-0.3C30,40.7,30.1,40.4,30.1,40.1z"/>
                    <path d="M42.1,34.7h-3v8.1h-2.4v-8.1h-2.9v-1.9h8.3C42.1,32.8,42.1,34.7,42.1,34.7z"/>
                    <path d="M13.6,34.7h-3v8.1H8.2v-8.1H5.3v-1.9h8.3C13.6,32.8,13.6,34.7,13.6,34.7z"/>
                    <path d="M21.8,38.6H18V41h4.6v1.8h-7v-10h7v1.9H18v2.2h3.8V38.6z"/>
                </g>
                    <path d="M24,30c-0.4,0-0.8-0.1-1.1-0.4c-0.3-0.3-0.4-0.6-0.4-1.1v-9h-9c-0.4,0-0.8-0.1-1.1-0.4C12.1,18.8,12,18.4,12,18
	s0.1-0.8,0.4-1.1c0.3-0.3,0.6-0.4,1.1-0.4h9v-9c0-0.4,0.1-0.8,0.4-1.1C23.2,6.1,23.6,6,24,6s0.8,0.1,1.1,0.4
	c0.3,0.3,0.4,0.6,0.4,1.1v9h9c0.4,0,0.8,0.1,1.1,0.4c0.3,0.3,0.4,0.6,0.4,1.1s-0.1,0.8-0.4,1.1c-0.3,0.3-0.6,0.4-1.1,0.4h-9v9
	c0,0.4-0.1,0.8-0.4,1.1C24.8,29.9,24.4,30,24,30z"/>

            </IconBase></span>
        </Tooltip>
    )
}

export default AddPreTestIcon;
